export default {
	user_is_not_an_attendance: "Este usuário não é um atendente. Entre como gestor.",

	invitation_request_already_exists_for_this_email: "Já existe uma solicitação criada para esse email.",
	this_email_is_already_linked_to_an_instance: "Este email já está vinculado a uma organização.",
	have_users_in_team: "Exclusão não permitida, pois existem atendentes vinculados a essa equipe",
	required_more_than_one_admin_per_account: "Necessário ter mais de um \"gestor\" na conta para poder alterar esse usuário para atendente."
}
